export enum ColorTheme {
  Dark = "dark",
  Light = "light",
}

export interface ColorThemeChangeEventPayload {
  colorTheme: ColorTheme;
}

export interface ColorThemeChangeSubscriberEventPayload {
  newColorTheme: ColorTheme;
}

export interface OnColorThemeChanged {
  unsubscribe: () => void;
}

export type OnColorThemeChangedSubscriberFn = (payload: ColorThemeChangeSubscriberEventPayload) => unknown;
